import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { STORE_NAMES } from './constants';

export interface ReportTask {
  taskId: string;
  eventId?: string;
  deliveryName?: string;
}

interface ReportTasksState {
  activeTasks: ReportTask[];
  addTask: (task: ReportTask) => void;
  removeTask: (taskId: string) => void;
}

export const useReportTasksStore = create<ReportTasksState>()(
  devtools(
    persist(
      (set, get) => ({
        activeTasks: [],
        addTask: (task: ReportTask) => {
          const existing = get().activeTasks.find((t) => t.taskId === task.taskId);
          if (!existing && task.taskId) {
            set({ activeTasks: [...get().activeTasks, task] }, undefined, 'reportTasks/addTask');
          }
        },
        removeTask: (taskId: string) => {
          set(
            { activeTasks: get().activeTasks.filter((t) => t.taskId !== taskId) },
            undefined,
            'reportTasks/removeTask',
          );
        },
      }),
      { name: STORE_NAMES.REPORT_TASKS },
    ),
    {
      name: STORE_NAMES.REPORT_TASKS,
      enabled: process.env.NODE_ENV === 'development',
    },
  ),
);
